import React from 'react';
import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from '@/components/Header';

function BaseLayout() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      <Header />
      <motion.main
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="w-full max-w-7xl mx-auto p-4 sm:p-6 lg:p-8"
      >
        <Outlet />
      </motion.main>
    </div>
  );
}

export default BaseLayout;